import { parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * Validate and format a phone number against international formats using libphonenumber-js.
 * Returns formatted E.164 string (e.g. "+14155552671") if valid, or null if invalid.
 *
 * @param {string} number - The national digits or full international phone number
 * @param {string|null} countryCode - The ISO2 country code (e.g. "US", "GB")
 * @returns {string|null}
 */
export const validateAndFormatPhone = (number, countryCode = null) => {
  const raw = (number || '').trim();
  if (!raw) return null;

  try {
    // If raw already starts with +, parse directly as international number
    if (raw.startsWith('+')) {
      const phoneNumber = parsePhoneNumberFromString(raw);
      if (phoneNumber && phoneNumber.isValid()) {
        return phoneNumber.format('E.164');
      }
    }

    // If countryCode is an ISO2 code (e.g. 'US', 'LK')
    if (countryCode && /^[A-Za-z]{2}$/.test(countryCode)) {
      const phoneNumber = parsePhoneNumberFromString(raw, countryCode.toUpperCase());
      if (phoneNumber && phoneNumber.isValid()) {
        return phoneNumber.format('E.164');
      }
    }

    // If countryCode is a dial code (e.g. '+1', '+94', '1', '94')
    if (countryCode && /^\+?\d+$/.test(countryCode)) {
      const dialCode = countryCode.startsWith('+') ? countryCode : `+${countryCode}`;
      const cleanNum = raw.replace(/^0+/, ''); // strip leading national trunk prefix
      const phoneNumber = parsePhoneNumberFromString(`${dialCode}${cleanNum}`);
      if (phoneNumber && phoneNumber.isValid()) {
        return phoneNumber.format('E.164');
      }
    }

    // Fallback standard parse
    const fallback = parsePhoneNumberFromString(raw, countryCode);
    if (fallback && fallback.isValid()) {
      return fallback.format('E.164');
    }

    return null;
  } catch (err) {
    return null;
  }
};
